const LOG_TYPES = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
}
export default LOG_TYPES
export { LOG_TYPES }
